/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyGeography
 */
export interface PropertyGeography {
    /**
     * 
     * @type {number}
     * @memberof PropertyGeography
     */
    geographyId: number;
}

export function PropertyGeographyFromJSON(json: any): PropertyGeography {
    return PropertyGeographyFromJSONTyped(json, false);
}

export function PropertyGeographyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyGeography {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'geographyId': json['geographyId'],
    };
}

export function PropertyGeographyToJSON(value?: PropertyGeography | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'geographyId': value.geographyId,
    };
}


